class ComponentProductRecommendations extends Theme.Component {

  connectedCallback() {
    const url = this.dataset.url;

    if (!url) {
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const recommendations = html.querySelector("component-product-recommendations");

        if (recommendations) {
          this.innerHTML = recommendations.innerHTML;
        }
      });
  }
}

customElements.define("component-product-recommendations", ComponentProductRecommendations);
